<template>
  <b-form
    @submit.prevent="
      $emit('ok', {
        excludeFromAnalysis,
        reasonForExclusion,
      })
    "
  >
    <b-form-checkbox
      v-model="excludeFromAnalysis"
      :value="true"
      :unchecked-value="false"
      @change="
        $emit('input', {
          excludeFromAnalysis,
          reasonForExclusion,
        })
      "
      >this case should be excluded from the scientific analysis</b-form-checkbox
    >
    <b-form-group label="Reason for exclusion">
      <b-textarea
        v-model="reasonForExclusion"
        @input="
          $emit('input', {
            interruptTreatment,
            excludeFromAnalysis,
            resubmissionInDays,
            reasonForDropout,
            reasonForExclusion,
          })
        "
      />
      <div>You can fill in a number for some of the most common reasons:</div>
      <ol>
        <li>Additional face-to-face therapy</li>
        <li>Change in medication</li>
        <li>Suicidal tendencies or clinical risk</li>
        <li>Psychotic tendencies</li>
      </ol>
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  data() {
    return {
      excludeFromAnalysis: this.value.excludeFromAnalysis === true,
      reasonForExclusion: this.value.reasonForExclusion || null,
    }
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
  },
}
</script>
